module.exports = __webpack_public_path__ + "static/media/my-shoes-my-journey.4f82e7a1.png";